import { useState, useEffect } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { currentPostAtom, currentSlideAtom } from "../../atom";

import styled from "styled-components";
import { Button, Input, message } from "antd";

import { patchSlideData } from "../../api/slideAPI";
import { checkUserName } from "../../api/authAPI";

const InformationArea = () => {
  const [currentPost, setCurrentPost] = useRecoilState(currentPostAtom);
  const [currentSlide, setCurrentSlide] = useRecoilState(currentSlideAtom); 
  const [userName, setUserName] = useState<string>("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [informationContent, setInformationContent] = useState(currentSlide?.description || "");
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    if (!currentSlide || !currentSlide.slideId) return;
    
    try {
      setIsSaving(true);
      const requestData = {
        slideId: currentSlide.slideId,
        description: informationContent
      }
      await patchSlideData(requestData);
      
      // 🌟 1. 현재 슬라이드 전역 상태(Recoil) 즉시 업데이트 (뷰어 라벨 반영용)
      setCurrentSlide((prev: any) => ({
        ...prev,
        description: informationContent
      }));

      // 🌟 2. 전체 포스트 전역 상태(Recoil) 즉시 업데이트 (하단 썸네일 리스트 반영용)
      setCurrentPost((prevPost: any) => {
        // 기존 포스트의 slides 배열을 순회하며 현재 수정한 슬라이드를 찾아 description만 변경
        const updatedSlides = prevPost.slides.map((slide: any) => {
          if (slide.slideId === currentSlide.slideId) {
            // 찾았다! 이 슬라이드의 description을 새 내용으로 바꿈
            return { ...slide, description: informationContent };
          }
          // 다른 슬라이드들은 그대로 유지
          return slide;
        });

        // 변경된 slides 배열을 포함하는 새 포스트 객체 반환
        return {
          ...prevPost,
          slides: updatedSlides,
        };
      });
      setIsEditMode(false);
    } catch (error) {
      console.error(error);
      message.error("저장에 실패했습니다.");
    } finally {
      setIsSaving(false);
    }
  };

  const handleCancel = () => {
    setInformationContent(currentSlide?.description || "");
    setIsEditMode(false);
  };

  useEffect(() => {
    setInformationContent(currentSlide?.description || "");
    setIsEditMode(false);
  }, [currentSlide?.slideId]);

  useEffect(() => {
    checkUserName().then((name) => {
      setUserName(name);
    });
  }, []);

  return(
    <StInformationAreaContainer>
      <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
        <h3 style={{ margin: 0 }}>Slide Information</h3>
        {userName === currentPost.writer &&
        <div style={{ marginLeft: "auto" }}>
          {isEditMode ? (
            <div>
              <Button onClick={handleCancel} size="small" style={{ marginRight: "8px" }} disabled={isSaving}>Cancel</Button>
              <Button type="primary" onClick={handleSave} size="small" loading={isSaving}>Save</Button>
            </div>
          ) : (
            <Button onClick={() => setIsEditMode(true)} size="small">Edit</Button>
          )}
        </div>}
      </div>
      <StContent>
        <Input.TextArea
          value={informationContent}
          onChange={(e) => setInformationContent(e.target.value)}
          placeholder={isEditMode ? "슬라이드 정보를 입력해주세요..." : ""}
          readOnly={!isEditMode || isSaving}
          style={{
            backgroundColor: isEditMode ? "#fff" : "transparent",
            cursor: isEditMode ? "text" : "default",
            padding: isEditMode ? "8px" : "0",
            height: "100%",
            resize: "none",
            border: isEditMode ? undefined : "none",
            boxShadow: "none"
          }}
        />
      </StContent>
    </StInformationAreaContainer>
  )
};

const StInformationAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
`;

const StContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.7);
`;

export default InformationArea;